import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { toast } from "react-toastify";
import { FiUploadCloud } from "react-icons/fi";
import { BiHomeAlt } from "react-icons/bi";
import "styles/admin.css";

const AdminSubjectForm = ({ subject, onClose, fetchSubjects }) => {
  const [code, setCode] = useState(subject?.code || "");
  const [shortName, setShortName] = useState(subject?.shortName || "");
  const [fullName, setFullName] = useState(subject?.fullName || "");
  const [description, setDescription] = useState(subject?.description || "");
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);

  const API_BASE = "https://algoritm-api-edu.uz";

  useEffect(() => {
    if (subject?.imgUrl) {
      setPreview(`${API_BASE}/${subject.imgUrl}`);
    } else {
      setPreview(null);
    }
  }, [subject]);

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImage(file);
    if (file) {
      const reader = new FileReader();
      reader.onload = () => setPreview(reader.result);
      reader.readAsDataURL(file);
    } else {
      setPreview(null);
    }
  };

  const removeImage = (e) => {
    e.stopPropagation();
    setImage(null);
    setPreview(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("accessToken");

    try {
      let res;

      if (subject?.slug) {
        const payload = {
          Slug: subject.slug,
          Code: code,
          ShortName: shortName,
          FullName: fullName,
          Description: description,
        };

        res = await fetch(
          "https://algoritm-api-edu.uz/api/admin/Subjects/Update",
          {
            method: "PUT",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(payload),
          }
        );

        if (image) {
          const formData = new FormData();
          formData.append("Image", image);
          await fetch(
            `https://algoritm-api-edu.uz/api/admin/Subjects/UpdateImage/${subject.slug}`,
            {
              method: "PUT",
              headers: { Authorization: `Bearer ${token}` },
              body: formData,
            }
          );
        }
      } else {
        const formData = new FormData();
        formData.append("Code", code);
        formData.append("ShortName", shortName);
        formData.append("FullName", fullName);
        formData.append("Description", description);
        if (image) formData.append("Image", image);

        res = await fetch(
          "https://algoritm-api-edu.uz/api/admin/Subjects/Add",
          {
            method: "POST",
            headers: { Authorization: `Bearer ${token}` },
            body: formData,
          }
        );
      }

      const text = await res.text();
      if (res.ok) {
        toast.success(subject ? "Fan yangilandi!" : "Fan qo‘shildi!");
        onClose();
        fetchSubjects();
      } else {
        toast.error("Xato: " + text);
      }
    } catch (err) {
      toast.error("Internet bilan aloqa yo‘q!");
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="subject-form-container"
        onClick={onClose}
      >
        <motion.div
          initial={{ y: 100, scale: 0.9 }}
          animate={{ y: 0, scale: 1 }}
          exit={{ y: 100, scale: 0.9 }}
          transition={{ type: "spring", stiffness: 300, damping: 30 }}
          className="subject-form-wrapper"
          onClick={(e) => e.stopPropagation()}
          style={{ maxWidth: "none", width: "auto" }}
        >
          <motion.div
            className="banner-header"
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
          >
            <div className="breadcrumb">
              <BiHomeAlt className="home-icon" />
              <span className="breadcrumb-separator">›</span>
              <span className="breadcrumb-current">
                {subject ? "Tahrirlash" : "Yaratish"}
              </span>
            </div>
          </motion.div>

          <form className="subject-form" onSubmit={handleSubmit}>
            <label>Kod</label>
            <input
              value={code}
              onChange={(e) => setCode(e.target.value)}
              required
              placeholder="Masalan: MATH101"
            />

            <label>Qisqa nomi</label>
            <input
              value={shortName}
              onChange={(e) => setShortName(e.target.value)}
              required
              placeholder="Masalan: Math"
            />

            <label>To‘liq nomi</label>
            <input
              value={fullName}
              onChange={(e) => setFullName(e.target.value)}
              required
              placeholder="Masalan: Matematika asoslari"
            />

            <label>Rasm(Majburiy emas)</label>
            <div className="image-upload-box">
              <div
                className="upload-placeholder"
                onClick={() => document.getElementById("imageInput").click()}
              >
                {preview ? (
                  <div style={{ position: "relative" }}>
                    <img
                      src={preview}
                      alt="Preview"
                      style={{
                        width: "100%",
                        height: "180px",
                        objectFit: "cover",
                        borderRadius: "8px",
                      }}
                    />
                    <span
                      className="remove-file"
                      onClick={removeImage}
                      style={{
                        position: "absolute",
                        top: "8px",
                        right: "8px",
                        background: "rgba(255, 0, 0, 0.596)",
                        color: "white",
                        width: "32px",
                        height: "32px",
                        borderRadius: "50%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "20px",
                        cursor: "pointer",
                      }}
                    >
                      ×
                    </span>
                  </div>
                ) : (
                  <>
                    <FiUploadCloud size={22} />
                    {image ? (
                      <div className="file-info">
                        <p className="file-name">{image.name}</p>
                        <span className="remove-file" onClick={removeImage}>
                          ×
                        </span>
                      </div>
                    ) : (
                      <p>Rasm yuklang</p>
                    )}
                  </>
                )}
              </div>
              <input
                id="imageInput"
                type="file"
                accept="image/*"
                onChange={handleImageChange}
                hidden
              />
            </div>

            <label>Izoh(Majburiy emas)</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              rows="3"
              placeholder="Fan haqida qisqacha izoh..."
            ></textarea>

            <div className="form-buttons">
              <button type="submit" className="save-btn">
                Saqlash
              </button>
              <button type="button" onClick={onClose} className="cancel-btn">
                Bekor qilish
              </button>
            </div>
          </form>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AdminSubjectForm;
